import { render, staticRenderFns } from "./TermoAceiteCadastro.vue?vue&type=template&id=be76588c&scoped=true"
import script from "./TermoAceiteCadastro.vue?vue&type=script&lang=js"
export * from "./TermoAceiteCadastro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be76588c",
  null
  
)

export default component.exports